import { Directive, inject, Input, OnInit, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appComponentLoader]',
  standalone: true,
})
export class ComponentLoaderDirective implements OnInit {
  @Input() appComponentLoader!: unknown;
  @Input() data?: unknown;

  readonly #viewContainerRef = inject(ViewContainerRef);

  ngOnInit(): void {
    if (!this.appComponentLoader) return;
    const componentRef = this.#viewContainerRef.createComponent(this.appComponentLoader as never);
    if (componentRef.instance) {
      (componentRef.instance as Partial<{ data: unknown }>).data = this.data;
    }
  }
}
